import { Component, EventEmitter, HostListener, Input, OnChanges, Output } from '@angular/core';
import { LEGAL_DOCUMENTS, LEGAL_PAGE_URLS, LegalDocKey, LegalDocument } from '../legal-documents';

interface Segment {
  text: string;
  email: boolean;
}

interface SectionView {
  heading: string;
  paragraphs: Segment[][];
}

// One capture group, so String.split puts each matched address at an odd index.
const EMAIL_SPLIT = /([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/;

/**
 * Terms of Use / Privacy Policy reader used by the client and vendor
 * registration flows. Purely presentational: the parent owns the consent
 * checkbox and decides what "I agree" means (it ticks that checkbox).
 */
@Component({
  selector: 'app-legal-modal',
  templateUrl: './legal-modal.component.html',
  styleUrls: ['./legal-modal.component.scss'],
})
export class LegalModalComponent implements OnChanges {
  @Input({ required: true }) doc!: LegalDocKey;
  /** Hide the "I agree" button when the modal is opened for reading only. */
  @Input() showAgree = true;
  @Output() closed = new EventEmitter<void>();
  @Output() agreed = new EventEmitter<void>();

  document!: LegalDocument;
  pageUrl = '';
  sections: SectionView[] = [];

  // Built once per document rather than from a template method, which would
  // hand *ngFor fresh arrays on every change-detection pass and re-render the
  // whole document each time.
  ngOnChanges(): void {
    this.document = LEGAL_DOCUMENTS[this.doc];
    this.pageUrl = LEGAL_PAGE_URLS[this.doc];
    this.sections = this.document.sections.map((section) => ({
      heading: section.heading,
      paragraphs: section.paragraphs.map((text) =>
        text
          .split(EMAIL_SPLIT)
          .map((part, i) => ({ text: part, email: i % 2 === 1 }))
          .filter((segment) => segment.text !== ''),
      ),
    }));
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closed.emit();
  }
}
